<form #passwordForm="ngForm">
 

  <po-password
    class="po-sm-12"
    name="newPassword"
    [(ngModel)]="newPassword"
    p-clean
    p-error-pattern="invalid password"
    p-label="Nova senha"
    p-minlength="8"
    p-required
   
  >
  </po-password>

  <po-password
    class="po-sm-12"
    name="confirmNewPassword"
    [(ngModel)]="confirmNewPassword"
    p-clean
    p-error-pattern="invalid password"
    p-label="Confirme a nova senha"
    p-minlength="8"
    p-required
    
  >
  </po-password>

  <po-password
  class="po-sm-12"
  name="currentPassword"
  [(ngModel)]="currentPassword"
  p-clean
  p-label="Senha atual"
  p-required
  
>
</po-password>

  <div class="po-row">
    <po-button class="po-md-4" p-label="Salvar" [p-disabled]="passwordForm.invalid" (p-click)="setPassword()">
    </po-button>
    <po-button class="po-md-4" p-label="Sair" (p-click)="sair()">
    </po-button>
  </div>
</form>